module.exports = __webpack_public_path__ + "static/media/ic_ar-wallet-primary.047e43bf.svg";